<template>
  <div v-if="data" class="contentful-tile" :class="{ 'has-link': data.link, bleedout: data.fullWidth, 'to-edge': data.fullWidth }">
    <suspense>
      <ContentfulResponsiveAsset v-bind="data.assets" :lazy="false" class="thumbnail" @updated="assetUpdated()">
        <template v-slot:description-override>
          <div class="preview">
            <div>{{ data.content }}</div>
            <div class="tile-link" v-if="data.link">
              <a :class="{ 'btn tiny outlined coral': linkType === 'button', accent: linkType === 'link' }" :href="data.link">
                <slot name="link-text-override">{{ data.linkText }}</slot>
              </a>
            </div>
          </div>
        </template>
      </ContentfulResponsiveAsset>
    </suspense>
  </div>
</template>

<script>
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import ContentfulResponsiveAsset from './ContentfulResponsiveAsset.vue';

export default {
  components: {
    ContentfulResponsiveAsset,
  },
  props: {
    ...contentfulProps,
    linkType: {
      type: String, // link | button
      default: 'link',
    },
  },
  async setup(p, c) {
    const { data, init } = useContentful('pageComponentTile', p, c);
    const assetUpdated = () => {
      c.emit('assetUpdated');
    };

    await init()
    return { data, assetUpdated };
  },
};
</script>

<style lang="postcss">
.contentful-tile {
  display: inherit;
}
</style>
